import { SchedulerRecordType } from '../enums';

export class SchedulerModel {
    public ID: number;
    public Name: string;
    public PracticeID: number;
    public BranchID?: number;
    public Color: string;
    public DefaultDuration?: number;
    public RecordType: SchedulerRecordType;
    public RecordID: number;
    public MaxOverlappingMetting?: number;
    public NoMandatoryVisitReason: boolean;
    public AssignmentRoomID? : number;
    public IsRoomRequired: boolean;

    constructor(obj? : any){
        this.ID = obj && obj.ID || null;
        this.Name = obj && obj.Name || null;
        this.PracticeID = obj && obj.PracticeID || null;

        if(obj && obj.PractiseID){
            this.PracticeID = obj.PractiseID;
        }

        this.BranchID = obj && obj.BranchID || null;
        this.Color = obj && obj.Color || null;
        this.DefaultDuration = obj && obj.DefaultDuration || null;
        this.RecordType = obj && obj.RecordType || null;
        this.RecordID = obj && obj.RecordID || null;
        this.MaxOverlappingMetting = obj && obj.MaxOverlappingMetting || null;
        this.NoMandatoryVisitReason = obj && obj.NoMandatoryVisitReason || false;
        this.AssignmentRoomID = obj && obj.AssignmentRoomID || null;
        this.IsRoomRequired = obj?.IsRoomRequired ?? false;
    }

}
